(function(){
  const catalog = {
  "version": "srd-font-catalog-v1",
  "entries": [
    {
      "id": "aachen-bold",
      "label": "Aachen Bold",
      "internalFamily": "Aachen BT",
      "fullName": "Aachen Bold BT",
      "postScriptName": "AachenBT-Bold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "SRD-Approved/AachenBTBold.ttf",
      "sourceSha256": "3ec11e6523663301e76fefafa772fd556ef2c53f9fc9927520f9b6f36ed43336",
      "themeAsset": "srd-font-aachen-bold-3ec11e652366.woff2",
      "cssFamily": "SRD Catalog aachen-bold 3ec11e652366",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/AachenBTBold.ttf",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "80a31dca48cee34cab41026be3b200f78699ff88f000e8f649a6c6748218a40c"
    },
    {
      "id": "abraham-stamp",
      "label": "Abraham Stamp",
      "internalFamily": "Abraham Stamp",
      "fullName": "Abraham Stamp Stamp",
      "postScriptName": "AbrahamStamp-Stamp",
      "style": "Stamp",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/abraham reguler free.otf",
      "sourceSha256": "cdf3e894de7337d3a60993e3a6492b2a3dd2e46206634fc1997d0036c4389d2c",
      "themeAsset": "srd-font-abraham-stamp-cdf3e894de73.woff2",
      "cssFamily": "SRD Catalog abraham-stamp cdf3e894de73",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/abraham reguler free.otf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "8b9fe2d63d1670b9be4609e6032ca9455d247689cebee36b5f34ae3d784557bb"
    },
    {
      "id": "agincort-condensed",
      "label": "Agincort Condensed",
      "internalFamily": "AgincortCondensed",
      "fullName": "AgincortCondensed",
      "postScriptName": "AgincortCondensed",
      "style": "Regular",
      "weight": 400,
      "italic": true,
      "source": "Die-Cutting-Approved-Fonts/AgincortCondensed.ttf",
      "sourceSha256": "6cb5cefb55634e53b192721473ee039c5bf8776848f02c060325159819b32ecb",
      "themeAsset": "srd-font-agincort-condensed-6cb5cefb5563.woff2",
      "cssFamily": "SRD Catalog agincort-condensed 6cb5cefb5563",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/AgincortCondensed.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "f1dbe55486c5bc4a686e04a033d3be6b72de69c71a66788d35827d4978619147"
    },
    {
      "id": "aldine721-roman",
      "label": "Aldine 721",
      "internalFamily": "Aldine721 BT",
      "fullName": "Aldine721 BT Roman",
      "postScriptName": "Aldine721BT-Roman",
      "style": "Roman",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Ald721Rm.ttf",
      "sourceSha256": "775c171b3836e74d1ff75f8c054439ebd86949d4331645179f4e062e41b4a79b",
      "themeAsset": "srd-font-aldine721-roman-775c171b3836.woff2",
      "cssFamily": "SRD Catalog aldine721-roman 775c171b3836",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Ald721Rm.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "a53797ca7a668313a62f2022ba0fe49b08711096865abd38a7580677626f1b48"
    },
    {
      "id": "alfa",
      "label": "Alfa Slab One",
      "internalFamily": "Alfa Slab One",
      "fullName": "Alfa Slab One Regular",
      "postScriptName": "AlfaSlabOne-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/TTF/alfa-slab-one-v19-latin-regular.ttf",
      "sourceSha256": "8624f217f4dc33429390185e20e48c2f47ca9e447cddc9a49462c41438d64e0f",
      "themeAsset": "srd-font-alfa-slab-one.woff2",
      "cssFamily": "SRD Alfa Slab One",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/TTF/alfa-slab-one-v19-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "638fdd4f2b3495c86b7ce26ff283968ee4b703a672bb59f62c1810f42912991d"
    },
    {
      "id": "algerian",
      "label": "Algerian",
      "internalFamily": "Algerian",
      "fullName": "Algerian",
      "postScriptName": "Algerian",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/ALGER.TTF",
      "sourceSha256": "d0b3b7cd48a047cdb7fa610d060807be44fca80f05ce4bf7557c4800f908e48a",
      "themeAsset": "srd-font-algerian-d0b3b7cd48a0.woff2",
      "cssFamily": "SRD Catalog algerian d0b3b7cd48a0",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/ALGER.TTF",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "4edaa368dfaaaba99dc0a2f5c8eeced9db6b7b15c8af3082d478a696dda445ac"
    },
    {
      "id": "american-captain",
      "label": "American Captain",
      "internalFamily": "American Captain",
      "fullName": "American Captain",
      "postScriptName": "AmericanCaptain",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/American Captain.ttf",
      "sourceSha256": "0ffb63e3554242a821003a4a770b653a14136d2a4e522626d61ea8f3e841589c",
      "themeAsset": "srd-font-american-captain-0ffb63e35542.woff2",
      "cssFamily": "SRD Catalog american-captain 0ffb63e35542",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/American Captain.ttf",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "b593fb3d7e740f23f3a2b28d322d1b91807cdbaea0dc1d920def104dad36092f"
    },
    {
      "id": "anton",
      "label": "Anton",
      "internalFamily": "Anton",
      "fullName": "Anton Regular",
      "postScriptName": "Anton-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/TTF/anton-v23-latin-regular.ttf",
      "sourceSha256": "7ea6ed673196b0f443eaf239aa86545906d822e99fb86b266c4d9061c13cbe21",
      "themeAsset": "srd-font-anton.woff2",
      "cssFamily": "SRD Anton",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/TTF/anton-v23-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "85f4e3247b1f98102e9a8883f302c6e2c8211c20007658c24ed78fbe7134727a"
    },
    {
      "id": "archivo-black",
      "label": "Archivo Black",
      "internalFamily": "Archivo Black",
      "fullName": "Archivo Black Regular",
      "postScriptName": "ArchivoBlack-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/archivo-black-v17-latin-regular.ttf",
      "sourceSha256": "f0c361fecb86002f2204129aa77d19afb70af9fbc5259c44b0798553b942b87e",
      "themeAsset": "srd-font-archivo-black-f0c361fecb86.woff2",
      "cssFamily": "SRD Catalog archivo-black f0c361fecb86",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/archivo-black-v17-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "75f217cef8d1e1b52e7fbb12b1762ca4c896d0986ff7d87b2e30e18370413d33"
    },
    {
      "id": "arezzo-rounded-bold",
      "label": "Arezzo Rounded Bold",
      "internalFamily": "Arezzo-Rounded-Bold",
      "fullName": "Arezzo-Rounded-Bold-Regular",
      "postScriptName": "ArezzoRoundedBold",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/Arezzo Rounded Bold Regular.ttf",
      "sourceSha256": "265abcb64a0f7c10af5856d5592cc60a8af93555bf881916455c6e72f503db94",
      "themeAsset": "srd-font-arezzo-rounded-bold-265abcb64a0f.woff2",
      "cssFamily": "SRD Catalog arezzo-rounded-bold 265abcb64a0f",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/Arezzo Rounded Bold Regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "0e80a0c10b93973cd4c5bf8dbc99225bf5323f42ef3b6a78100627ef03144a4b"
    },
    {
      "id": "arial",
      "label": "Arial Bold",
      "internalFamily": "Arial",
      "fullName": "Arial Bold",
      "postScriptName": "Arial-BoldMT",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "legacy-v3.9-local-font",
      "sourceSha256": "",
      "themeAsset": "",
      "cssFamily": "SRD Arial Bold",
      "browserFormat": "local",
      "productionFontReference": "",
      "workflows": [
        "print_design"
      ],
      "legacyCompatibility": true
    },
    {
      "id": "arial-rounded-bold",
      "label": "Arial Rounded Bold",
      "internalFamily": "Arial Rounded MT Bold",
      "fullName": "Arial Rounded MT Bold",
      "postScriptName": "ArialRoundedMTBold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/arial rounded mt bold.ttf",
      "sourceSha256": "9525db26b34f9ad5bc66b9c26ba2eec8f2cdb6b9eb2ed706c103a1d23f80cd9e",
      "themeAsset": "srd-font-arial-rounded-bold-9525db26b34f.woff2",
      "cssFamily": "SRD Catalog arial-rounded-bold 9525db26b34f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/arial rounded mt bold.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "7caf75e08e17965064d051fd1c885729eadccc267235a35a8685fceefcd056d6"
    },
    {
      "id": "bangers",
      "label": "Bangers",
      "internalFamily": "Bangers",
      "fullName": "Bangers Regular",
      "postScriptName": "Bangers-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/bangers-v20-latin-regular.ttf",
      "sourceSha256": "95948bbe48ff3286b86b0636629a7f513645e97c90628cc1ae95d5ebd5907c8c",
      "themeAsset": "srd-font-bangers-95948bbe48ff.woff2",
      "cssFamily": "SRD Catalog bangers 95948bbe48ff",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/bangers-v20-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "057b6d8ad34ee8272aef6b715c9f9bda73580f817520271e69c9ff8b2910b968"
    },
    {
      "id": "bebas-neue",
      "label": "Bebas Neue",
      "internalFamily": "Bebas Neue",
      "fullName": "Bebas Neue Regular",
      "postScriptName": "BebasNeue-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/bebas-neue-v9-latin-regular.ttf",
      "sourceSha256": "eabd3d2381a8c6137c7f38dc505ad9f3318ebaf6746b131cbddec6ca829377f1",
      "themeAsset": "srd-font-bebas-neue-eabd3d2381a8.woff2",
      "cssFamily": "SRD Catalog bebas-neue eabd3d2381a8",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/bebas-neue-v9-latin-regular.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "e8d0c883008df8d311c52ca20295c156d6d88617d3ac2c254c1aa7a83a43b1bb"
    },
    {
      "id": "berlin-sans-regular",
      "label": "Berlin Sans",
      "internalFamily": "Berlin Sans FB",
      "fullName": "Berlin Sans FB",
      "postScriptName": "BerlinSansFB-Reg",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/BRLNSR.TTF",
      "sourceSha256": "0b6044c72e67aaae9c2ae3c8b4bb06d066fdbc02779c68e3883984acbbe24cb8",
      "themeAsset": "srd-font-berlin-sans-regular-0b6044c72e67.woff2",
      "cssFamily": "SRD Catalog berlin-sans-regular 0b6044c72e67",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/BRLNSR.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "d3dbc3aba5754e881c96e1827621dc3d25785dc58a073ade1ff5e0e59b542e72"
    },
    {
      "id": "berlin-sans-bold",
      "label": "Berlin Sans Bold",
      "internalFamily": "Berlin Sans FB",
      "fullName": "Berlin Sans FB Bold",
      "postScriptName": "BerlinSansFB-Bold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/BRLNSB.TTF",
      "sourceSha256": "ad7d00c413fe11ec423ff5e2b63da7d403049ab3babf13d0b2ab34a43f4d4a55",
      "themeAsset": "srd-font-berlin-sans-bold-ad7d00c413fe.woff2",
      "cssFamily": "SRD Catalog berlin-sans-bold ad7d00c413fe",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/BRLNSB.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "bbbf773eb0a0698c819b9b3446767641f891566a088c0a25abd78157df813ae5"
    },
    {
      "id": "berlin-sans-demi-bold",
      "label": "Berlin Sans Demi Bold",
      "internalFamily": "Berlin Sans FB Demi",
      "fullName": "Berlin Sans FB Demi Bold",
      "postScriptName": "BerlinSansFBDemi-Bold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/BRLNSDB.TTF",
      "sourceSha256": "4c50d832f4e1401e226566159735dae932dd224d795ac57772061096117e4147",
      "themeAsset": "srd-font-berlin-sans-demi-bold-4c50d832f4e1.woff2",
      "cssFamily": "SRD Catalog berlin-sans-demi-bold 4c50d832f4e1",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/BRLNSDB.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "759ac2b8e90adea9a08d7a5df079bb5758c29ff74c11ee25d601377e83252d26"
    },
    {
      "id": "bondy-quirky",
      "label": "Bondy Quirky",
      "internalFamily": "Bondy Quirky",
      "fullName": "BondyQuirky-Regular",
      "postScriptName": "BondyQuirky-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/BondyquirkyRegular-ywG33.otf",
      "sourceSha256": "8f6bd312ad947051583bb03c4c5272311da9b73e4cc56867e4ee7ad6188e1757",
      "themeAsset": "srd-font-bondy-quirky-8f6bd312ad94.woff2",
      "cssFamily": "SRD Catalog bondy-quirky 8f6bd312ad94",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/BondyquirkyRegular-ywG33.otf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "700d06e9906e1cce534ad00b84ad46b8f205c0b380e2d76627247dbf1b14e8ce"
    },
    {
      "id": "bowlby",
      "label": "Bowlby One SC",
      "internalFamily": "Bowlby One SC",
      "fullName": "Bowlby One SC Regular",
      "postScriptName": "BowlbyOneSC-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/TTF/bowlby-one-sc-v19-latin-regular.ttf",
      "sourceSha256": "a86464c2e8cb8406a72ba3b42a84953cda044433881c2dd5b18f43f88c87df59",
      "themeAsset": "srd-font-bowlby-one-sc.woff2",
      "cssFamily": "SRD Bowlby One SC",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/TTF/bowlby-one-sc-v19-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "39b8b5fc592645707c81cc3ad89aa15d3703aec8923ff1037e4d8626eb021616"
    },
    {
      "id": "broadway",
      "label": "Broadway",
      "internalFamily": "Broadway",
      "fullName": "Broadway",
      "postScriptName": "Broadway",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/BROADW.TTF",
      "sourceSha256": "a252b1e5d460f1e0e4781146186393e5b217ab379db237c7bcb8d7c353943edc",
      "themeAsset": "srd-font-broadway-a252b1e5d460.woff2",
      "cssFamily": "SRD Catalog broadway a252b1e5d460",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/BROADW.TTF",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "d29bdf7cb29ec52b14b49104ff26cfe5fdbd5393feae9bff609b68fedc68fe01"
    },
    {
      "id": "brush-stroke-26-bold-italic",
      "label": "Brush Stroke 26 Bold Italic",
      "internalFamily": "Brush Stroke 26",
      "fullName": "Brush Stroke 26 BoldItalic",
      "postScriptName": "BrushStroke26BoldItalic",
      "style": "BoldItalic",
      "weight": 700,
      "italic": true,
      "source": "Die-Cutting-Approved-Fonts/Brush Stroke 26 BoldItalic.TTF",
      "sourceSha256": "bcecf4f3222715a3defe7706394ef1e758cb6de6193fa6de6a8ea948bcab6458",
      "themeAsset": "srd-font-brush-stroke-26-bold-italic-bcecf4f32227.woff2",
      "cssFamily": "SRD Catalog brush-stroke-26-bold-italic bcecf4f32227",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Brush Stroke 26 BoldItalic.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "245953f2a348d08a2ba880475820e0f6ea78f82c96b93b88f32ed9793af0d35f"
    },
    {
      "id": "caligula",
      "label": "Caligula",
      "internalFamily": "Caligula",
      "fullName": "CaligulaA",
      "postScriptName": "CaligulaA",
      "style": "A",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Caligula.TTF",
      "sourceSha256": "2c8ff5d98643ea1aaf4c48069fd7b1ab8113520a6cb2e8c00eec6a9136cb6ee4",
      "themeAsset": "srd-font-caligula-2c8ff5d98643.woff2",
      "cssFamily": "SRD Catalog caligula 2c8ff5d98643",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Caligula.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "ff1e58a9243fb35606a3aaf9fd923cb4dcd9be98a858eb1ad60df38d76a0d283"
    },
    {
      "id": "casual",
      "label": "Casual",
      "internalFamily": "Casual",
      "fullName": "Casual",
      "postScriptName": "",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/casual.ttf",
      "sourceSha256": "c322e4c40ed495fea4959c563eff4d92d0dfb1e9f789ad177a08ded1aa77e6cb",
      "themeAsset": "srd-font-casual-c322e4c40ed4.woff2",
      "cssFamily": "SRD Catalog casual c322e4c40ed4",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/casual.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "a3d70b13a838e816a41b8ade27329247aac0f9794ffe43fbc3927bdbff9ca416"
    },
    {
      "id": "certificate-bold-italic",
      "label": "Certificate Bold Italic",
      "internalFamily": "Certificate",
      "fullName": "Certificate BoldItalic",
      "postScriptName": "CertificateBoldItalic",
      "style": "BoldItalic",
      "weight": 700,
      "italic": true,
      "source": "SRD-Approved/Certificate BoldItalic.ttf",
      "sourceSha256": "c270237c5eaab13b14190724efa7e105541eb8ac5d003d8aa3867bfd002596fc",
      "themeAsset": "srd-font-certificate-bold-italic-c270237c5eaa.woff2",
      "cssFamily": "SRD Catalog certificate-bold-italic c270237c5eaa",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/Certificate BoldItalic.ttf",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "c3f564ac45c636d6b2778e409e998e8431387741bb28714feaf24bfd704aecc5"
    },
    {
      "id": "cowboy-regular",
      "label": "Cowboy",
      "internalFamily": "Cowboy",
      "fullName": "Cowboy Normal",
      "postScriptName": "CowboyNormal",
      "style": "Normal",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Normal.TTF",
      "sourceSha256": "430b814fd06c44a535675ad63d110158d29ce2b6e5a3000c726c10017f769f42",
      "themeAsset": "srd-font-cowboy-regular-430b814fd06c.woff2",
      "cssFamily": "SRD Catalog cowboy-regular 430b814fd06c",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Normal.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "812e910a75626f53c7ae4dde9848065b36e322d7fd852cdf528596a7faa6de45"
    },
    {
      "id": "cowboy-bold",
      "label": "Cowboy Bold",
      "internalFamily": "Cowboy",
      "fullName": "Cowboy Bold",
      "postScriptName": "CowboyBold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Bold.TTF",
      "sourceSha256": "4f180d5c1da55c478e21e8c956fc48012574a027af76ac930797f91de1c24ebb",
      "themeAsset": "srd-font-cowboy-bold-4f180d5c1da5.woff2",
      "cssFamily": "SRD Catalog cowboy-bold 4f180d5c1da5",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Bold.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "8c3b2e6ee788c0c95787e4deab1068e14e3962f61bd5f4e5431cb15b57120ae3"
    },
    {
      "id": "cowboy-bold-italic",
      "label": "Cowboy Bold Italic",
      "internalFamily": "Cowboy",
      "fullName": "Cowboy Bold Italic",
      "postScriptName": "CowboyBoldItalic",
      "style": "Bold Italic",
      "weight": 700,
      "italic": true,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Bold Italic.TTF",
      "sourceSha256": "d3122da7e75a5091aadbcd19f742f264df6777d9e9d93499df7f766b0340cb48",
      "themeAsset": "srd-font-cowboy-bold-italic-d3122da7e75a.woff2",
      "cssFamily": "SRD Catalog cowboy-bold-italic d3122da7e75a",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Bold Italic.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "df0e9b5653eef5a01aaccd059165749261f15d6309ba75011976ac6c340d6024"
    },
    {
      "id": "cowboy-italic",
      "label": "Cowboy Italic",
      "internalFamily": "Cowboy",
      "fullName": "Cowboy Italic",
      "postScriptName": "CowboyItalic",
      "style": "Italic",
      "weight": 400,
      "italic": true,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Italic.TTF",
      "sourceSha256": "671d254e5d241afdc8e8a5941bf724ce459755d723545a679c133fc885f42d5f",
      "themeAsset": "srd-font-cowboy-italic-671d254e5d24.woff2",
      "cssFamily": "SRD Catalog cowboy-italic 671d254e5d24",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Italic.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "aac5b8febc69d86c1b7acba445659491c2d7e37958263237b4662b45b4ba31a5"
    },
    {
      "id": "cowboy-thin",
      "label": "Cowboy Thin",
      "internalFamily": "Cowboy Thin",
      "fullName": "Cowboy Thin Normal",
      "postScriptName": "CowboyThinNormal",
      "style": "Normal",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Thin Normal.TTF",
      "sourceSha256": "f9d030cec66f29729f40ac98f35add5e8f0adebd578e826c9691b714613b76be",
      "themeAsset": "srd-font-cowboy-thin-f9d030cec66f.woff2",
      "cssFamily": "SRD Catalog cowboy-thin f9d030cec66f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Thin Normal.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "06f0aee855ffa4775242f794f2f80eba6de3332393f1543d56264e58fdb60e95"
    },
    {
      "id": "cowboy-thin-italic",
      "label": "Cowboy Thin Italic",
      "internalFamily": "Cowboy Thin",
      "fullName": "Cowboy Thin Italic",
      "postScriptName": "CowboyThinItalic",
      "style": "Italic",
      "weight": 400,
      "italic": true,
      "source": "Die-Cutting-Approved-Fonts/Cowboy Thin Italic.TTF",
      "sourceSha256": "45010ee3eeb9961f3b1b9e66503ffe6a4e0f88abe0c0d2e4537f5960e43bcb46",
      "themeAsset": "srd-font-cowboy-thin-italic-45010ee3eeb9.woff2",
      "cssFamily": "SRD Catalog cowboy-thin-italic 45010ee3eeb9",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Cowboy Thin Italic.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "e5c721ae79340b6ec0851ff47424a5c70717aa2ad34b839e94b95a3d514b55a3"
    },
    {
      "id": "cowboys",
      "label": "Cowboys",
      "internalFamily": "Cowboys",
      "fullName": "Cowboys",
      "postScriptName": "Cowboys",
      "style": "Solid",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/cowboys.ttf",
      "sourceSha256": "2fd05ad99cc63f4e7e002fa44ff4c3198c6969661b51a13f1b5ab9a7b2833541",
      "themeAsset": "srd-font-cowboys-2fd05ad99cc6.woff2",
      "cssFamily": "SRD Catalog cowboys 2fd05ad99cc6",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/cowboys.ttf",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "0f3541851ec687a54da1543575a8636fcfe784038f8608443531f8bf3448c189"
    },
    {
      "id": "curlz-mt",
      "label": "Curlz MT",
      "internalFamily": "Curlz MT",
      "fullName": "Curlz MT",
      "postScriptName": "CurlzMT",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/CURLZ___.TTF",
      "sourceSha256": "caf7d153d2860f395f846db58032173c3f76b57f9368ec08382f728742cf5a5d",
      "themeAsset": "srd-font-curlz-mt-caf7d153d286.woff2",
      "cssFamily": "SRD Catalog curlz-mt caf7d153d286",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/CURLZ___.TTF",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "0aecca102bbc66f1cd4987019c67401d87ca31ce600e9521db00edbdc5aafdc4"
    },
    {
      "id": "gt-brush-script",
      "label": "GT-Brush Script",
      "internalFamily": "GT-Brush Script",
      "fullName": "GT-Brush Script",
      "postScriptName": "GT-BrushScript",
      "style": "GT-Brush Script",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Brush Script.ttf",
      "sourceSha256": "4b05136fa075275ddbeb8e5db2b0db5e6d0f8bdae0cea51cf379054923b212be",
      "themeAsset": "srd-font-gt-brush-script-4b05136fa075.woff2",
      "cssFamily": "SRD Catalog gt-brush-script 4b05136fa075",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Brush Script.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "bbadf93aac718447f5ac08518ca727cf38840446104869662141ca54d3f98fd3"
    },
    {
      "id": "gt-casual-italic-script",
      "label": "GT-Casual Italic Script",
      "internalFamily": "GT-Causal Italic Script",
      "fullName": "GT-Causal Italic Script",
      "postScriptName": "GT-CausalItalicScript",
      "style": "Medium",
      "weight": 500,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Casual Italic Script.ttf",
      "sourceSha256": "26ebbeabe2f3954dab69944b4271999949904d37fa11f7c608c63e0bdc245bb0",
      "themeAsset": "srd-font-gt-casual-italic-script-26ebbeabe2f3.woff2",
      "cssFamily": "SRD Catalog gt-casual-italic-script 26ebbeabe2f3",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Casual Italic Script.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "5e8a16c78326ef8953a3bbbd28d656c09d92e6fff474d738a427808b0c40be52"
    },
    {
      "id": "gt-clarendon-fortune-bold",
      "label": "GT-Clarendon Fortune Bold",
      "internalFamily": "GT-Clarendon Fortune Bold",
      "fullName": "GT-Clarendon Fortune Bold",
      "postScriptName": "GT-ClarendonFortuneBold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Clarendon Fortune Bold.ttf",
      "sourceSha256": "2a6f2d5478b1234d7ed6e49465a1f0c72ca25413284ed320787324107aa207e7",
      "themeAsset": "srd-font-gt-clarendon-fortune-bold-2a6f2d5478b1.woff2",
      "cssFamily": "SRD Catalog gt-clarendon-fortune-bold 2a6f2d5478b1",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Clarendon Fortune Bold.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "5d952da63f5b836ff9397e7644b13e5a6c170626b11bcee6c1f777b648a978fd"
    },
    {
      "id": "gt-country-gothic",
      "label": "GT-Country Gothic",
      "internalFamily": "GT-Country Gothic",
      "fullName": "GT-Country Gothic",
      "postScriptName": "GT-CountryGothic",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Country Gothic.ttf",
      "sourceSha256": "91853a13c98f4b259f3b8efd3cb6d559395bbf7506b35730d59383c308841f0b",
      "themeAsset": "srd-font-gt-country-gothic-91853a13c98f.woff2",
      "cssFamily": "SRD Catalog gt-country-gothic 91853a13c98f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Country Gothic.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "f1ee523fe975704d4813c440b5111ae159e31fd83aa118169e575b0ff5a5f597"
    },
    {
      "id": "gt-craw-clarendon-condensed",
      "label": "GT-Craw Clarendon Condensed",
      "internalFamily": "GT-Craw Clarendon Condensed",
      "fullName": "GT-Craw Clarendon Condensed",
      "postScriptName": "GT-CrawClarendonCondensed",
      "style": "Medium",
      "weight": 500,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Craw Clarendon Condensed.ttf",
      "sourceSha256": "74acf60a4040d4d24889b1708ccfd84b295f15ee84f3c253da49d8f78bb85d1f",
      "themeAsset": "srd-font-gt-craw-clarendon-condensed-74acf60a4040.woff2",
      "cssFamily": "SRD Catalog gt-craw-clarendon-condensed 74acf60a4040",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Craw Clarendon Condensed.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "cf12b062ba20f6e331775944522d45a4ae19055a191c20a97a4b79bbf892259c"
    },
    {
      "id": "gt-handel-gothic",
      "label": "GT-Handel Gothic",
      "internalFamily": "GT-Handel Gothic",
      "fullName": "GT-Handel Gothic",
      "postScriptName": "GT-HandelGothic",
      "style": "Regular",
      "weight": 500,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Handel Gothic.ttf",
      "sourceSha256": "4000a5b449c0d7a17e7d3ad26e5aef6b3c6d0e2b01a2aa31ceb776f2c8715a69",
      "themeAsset": "srd-font-gt-handel-gothic-4000a5b449c0.woff2",
      "cssFamily": "SRD Catalog gt-handel-gothic 4000a5b449c0",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Handel Gothic.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "2e5ad67d8b4fde71d13ddf99e23628b5a7570681447eb9153d3feff9b5a248be"
    },
    {
      "id": "gt-microgramma-ext",
      "label": "GT-Microgramma Ext",
      "internalFamily": "GT-Microgramma Extended",
      "fullName": "GT-Microgramma Extended",
      "postScriptName": "GT-MicrogrammaExtended",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Microgramma Ext.ttf",
      "sourceSha256": "ba313834869e305f885ab5562c61d60e0ad0df3d2656ce7cae71736ece176333",
      "themeAsset": "srd-font-gt-microgramma-ext-ba313834869e.woff2",
      "cssFamily": "SRD Catalog gt-microgramma-ext ba313834869e",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Microgramma Ext.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "12068e70cfb45b5228649ea092e0251069618030d69d22431af9438c8b23d383"
    },
    {
      "id": "gt-old-english",
      "label": "GT-Old English",
      "internalFamily": "GT-Old English",
      "fullName": "GT-Old English",
      "postScriptName": "GT-OldEnglish",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Old English.ttf",
      "sourceSha256": "933b2bfeca91ee1add28dc2d357e917220ef79967d44a6dcf43338bb7ac8f4fa",
      "themeAsset": "srd-font-gt-old-english-933b2bfeca91.woff2",
      "cssFamily": "SRD Catalog gt-old-english 933b2bfeca91",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Old English.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "137f231bf9b5c9fe8ca7940f6cca5c1089583c0e805140132869ff6b1d827b56"
    },
    {
      "id": "gt-perfaire",
      "label": "GT-Perfaire",
      "internalFamily": "GT-Perfaire",
      "fullName": "GT-Perfaire",
      "postScriptName": "GT-Perfaire",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Perfaire.ttf",
      "sourceSha256": "0b84f224565f9a30e1baf9b3158a358423510ed87860976b1398f4aeda8abddb",
      "themeAsset": "srd-font-gt-perfaire-0b84f224565f.woff2",
      "cssFamily": "SRD Catalog gt-perfaire 0b84f224565f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Perfaire.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "5f1b395d3aa742a844d65916a41124b162b407061fa57eb1fad7fe96e582dfbc"
    },
    {
      "id": "gt-playbill",
      "label": "GT-Playbill",
      "internalFamily": "GT-Playbill",
      "fullName": "GT-Playbill",
      "postScriptName": "GT-Playbill",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Playbill.ttf",
      "sourceSha256": "ca670de3287dcdad0c236b49b57aa28c34f4d57ec77cff169de7dc9a23577551",
      "themeAsset": "srd-font-gt-playbill-ca670de3287d.woff2",
      "cssFamily": "SRD Catalog gt-playbill ca670de3287d",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Playbill.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "4a29992fbc2679ba1cd3639ffbd6c3b36a8a58dd8465e4fd235199c0cd2741cf"
    },
    {
      "id": "gt-romic-bold",
      "label": "GT-Romic Bold",
      "internalFamily": "GT-Romic",
      "fullName": "GT-Romic Bold",
      "postScriptName": "GT-Romic-Bold",
      "style": "Bold",
      "weight": 700,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/GT-Romic Bold.ttf",
      "sourceSha256": "87535217800f6096cd7079b58e96a831b3eb7a94a189d519acd797bb766b67ae",
      "themeAsset": "srd-font-gt-romic-bold-87535217800f.woff2",
      "cssFamily": "SRD Catalog gt-romic-bold 87535217800f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/GT-Romic Bold.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "1f30b40ec7976d0c76147d0a4bb6a8d8b472afabef88c21fc0a40707fe839cff"
    },
    {
      "id": "impact",
      "label": "Impact",
      "internalFamily": "Impact",
      "fullName": "Impact",
      "postScriptName": "Impact",
      "style": "Regular",
      "weight": 700,
      "italic": false,
      "source": "legacy-v3.9-local-font",
      "sourceSha256": "",
      "themeAsset": "",
      "cssFamily": "SRD Impact",
      "browserFormat": "local",
      "productionFontReference": "",
      "workflows": [
        "print_design"
      ],
      "legacyCompatibility": true
    },
    {
      "id": "letrista-script",
      "label": "Letrista Script",
      "internalFamily": "Letrista Script",
      "fullName": "LetristaScript",
      "postScriptName": "LetristaScript",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/LetristaScript.otf",
      "sourceSha256": "92b3df5474eb59c4333ef3e7687906a9f4e8f967f4aa31a42466d4592b8a52fe",
      "themeAsset": "srd-font-letrista-script-92b3df5474eb.woff2",
      "cssFamily": "SRD Catalog letrista-script 92b3df5474eb",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/LetristaScript.otf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "2d596375954f5c9b32bb142d062d1efc2e26b9995ef442c653a3cecce7831154"
    },
    {
      "id": "luckiest-guy",
      "label": "Luckiest Guy",
      "internalFamily": "Luckiest Guy",
      "fullName": "Luckiest Guy Regular",
      "postScriptName": "LuckiestGuy-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/luckiest-guy-v18-latin-regular.ttf",
      "sourceSha256": "47f7d9fbebf8b0f6d5e83e234b9fdb198340f879f6ab5679a41871c07d2d8f60",
      "themeAsset": "srd-font-luckiest-guy-47f7d9fbebf8.woff2",
      "cssFamily": "SRD Catalog luckiest-guy 47f7d9fbebf8",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/luckiest-guy-v18-latin-regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "d97b9c138e00f9ebe96ae621a369c6648a82b378922025d5f5abf014cf1ebff9"
    },
    {
      "id": "mainstay",
      "label": "Mainstay",
      "internalFamily": "Mainstay",
      "fullName": "Mainstay",
      "postScriptName": "Mainstay",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/Mainstay.ttf",
      "sourceSha256": "1963671db547139f86004b981e8b7c9bccb8cd05f8f15a325164877ddd2669cd",
      "themeAsset": "srd-font-mainstay-1963671db547.woff2",
      "cssFamily": "SRD Catalog mainstay 1963671db547",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/Mainstay.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "f135518b0ec968fe1847932d6b323edfeb15b3efbabe37c60264f03ea3dc6ea9"
    },
    {
      "id": "marons",
      "label": "Marons",
      "internalFamily": "Marons",
      "fullName": "Marons Regular",
      "postScriptName": "Marons-Regular",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/Marons-Regular.ttf",
      "sourceSha256": "d78f0ca80e836930fc6a14d63cabc46721dd59b9925e5a08ebd96a2495f65bb6",
      "themeAsset": "srd-font-marons-d78f0ca80e83.woff2",
      "cssFamily": "SRD Catalog marons d78f0ca80e83",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/Marons-Regular.ttf",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "6ee8b2992c20abd38ff729c802fe8811b09da19ea0ebdc03582064c3d562f673"
    },
    {
      "id": "metro",
      "label": "Metro",
      "internalFamily": "Metro",
      "fullName": "Metro Regular",
      "postScriptName": "Metro",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/Metro Regular.ttf",
      "sourceSha256": "507ae241843067149749d7b109ca638c21413fe8d8089c2442885b0ea451c61a",
      "themeAsset": "srd-font-metro-507ae2418430.woff2",
      "cssFamily": "SRD Catalog metro 507ae2418430",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/Metro Regular.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "77e0b08ecf0e79cbce212566a2364ef01f3285c7574ca6d88f772846de072fc1"
    },
    {
      "id": "planet-kosmos",
      "label": "Planet Kosmos",
      "internalFamily": "Planet Kosmos",
      "fullName": "Planet Kosmos",
      "postScriptName": "PlanetKosmos",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/PLANK.TTF",
      "sourceSha256": "289cdf05be074bc34874765fdd434ff70521fc648e55f3eac73a449924a46091",
      "themeAsset": "srd-font-planet-kosmos-289cdf05be07.woff2",
      "cssFamily": "SRD Catalog planet-kosmos 289cdf05be07",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/PLANK.TTF",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "f9ac4f4dcfd43b838f91bc9f95208137b89bc162cd3b8115dce91df7eca6bc7a"
    },
    {
      "id": "saloonext",
      "label": "Saloon Extended",
      "internalFamily": "SaloonExt",
      "fullName": "SaloonExt",
      "postScriptName": "SaloonExt",
      "style": "Regular",
      "weight": 600,
      "italic": false,
      "source": "Die-Cutting-Approved-Fonts/SaloonExt.ttf",
      "sourceSha256": "7d5d969bd63f32aed7227d7e325073e937a074f854f7b936aeaffc322609bafb",
      "themeAsset": "srd-font-saloonext-7d5d969bd63f.woff2",
      "cssFamily": "SRD Catalog saloonext 7d5d969bd63f",
      "browserFormat": "woff2",
      "productionFontReference": "Die-Cutting-Approved-Fonts/SaloonExt.ttf",
      "workflows": [
        "die_cutting"
      ],
      "assetSha256": "1677d8e2d7061c884e5e76e55e7229f7c7ed3518f15ed5054c791c7391deaac2"
    },
    {
      "id": "saloonext-th",
      "label": "Saloon Extended Thin",
      "internalFamily": "SaloonExt Th",
      "fullName": "SaloonExt Th",
      "postScriptName": "SaloonExtTh",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/SaloonExt Th.ttf",
      "sourceSha256": "c4a03bf7962262d64bfe67710a9525e80defe68663e1b296ca6a16404dcf03d0",
      "themeAsset": "srd-font-saloonext-th-c4a03bf79622.woff2",
      "cssFamily": "SRD Catalog saloonext-th c4a03bf79622",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/SaloonExt Th.ttf",
      "workflows": [
        "print_design"
      ],
      "assetSha256": "46c8176d9b5e691ab3f0903f97a19d4704c3d9e8310a6ebc5fceb8b15f4e8218"
    },
    {
      "id": "stencil",
      "label": "Stencil",
      "internalFamily": "Stencil",
      "fullName": "Stencil",
      "postScriptName": "Stencil",
      "style": "Regular",
      "weight": 400,
      "italic": false,
      "source": "SRD-Approved/STENCIL.TTF",
      "sourceSha256": "5d53b38fa8ff33d15676cdcd78b261681bfda861c449b4f7ddfd7574a5c11e18",
      "themeAsset": "srd-font-stencil-5d53b38fa8ff.woff2",
      "cssFamily": "SRD Catalog stencil 5d53b38fa8ff",
      "browserFormat": "woff2",
      "productionFontReference": "SRD-Approved/STENCIL.TTF",
      "workflows": [
        "print_design",
        "die_cutting"
      ],
      "assetSha256": "7b21536c89707861cc4750dfed4c3b6b3491feec80bfc33386999c96548595c9"
    }
  ],
  "workflows": {
    "print_design": [
      "arial",
      "impact",
      "anton",
      "bowlby",
      "alfa",
      "aachen-bold",
      "algerian",
      "american-captain",
      "archivo-black",
      "arezzo-rounded-bold",
      "bangers",
      "broadway",
      "certificate-bold-italic",
      "cowboys",
      "luckiest-guy",
      "mainstay",
      "marons",
      "planet-kosmos",
      "saloonext-th",
      "stencil"
    ],
    "die_cutting": [
      "abraham-stamp",
      "aldine721-roman",
      "alfa",
      "anton",
      "archivo-black",
      "arezzo-rounded-bold",
      "arial-rounded-bold",
      "bangers",
      "bebas-neue",
      "berlin-sans-regular",
      "berlin-sans-bold",
      "berlin-sans-demi-bold",
      "bondy-quirky",
      "bowlby",
      "casual",
      "curlz-mt",
      "letrista-script",
      "luckiest-guy",
      "mainstay",
      "marons",
      "metro",
      "planet-kosmos",
      "saloonext",
      "stencil",
      "gt-microgramma-ext",
      "gt-old-english",
      "gt-perfaire",
      "gt-playbill",
      "gt-romic-bold",
      "gt-brush-script",
      "gt-casual-italic-script",
      "gt-clarendon-fortune-bold",
      "gt-country-gothic",
      "gt-craw-clarendon-condensed",
      "gt-handel-gothic"
    ]
  },
  "defaults": {
    "print_design": "arial",
    "die_cutting": "berlin-sans-regular"
  }
};
  window.SRDDesignerFontCatalog = Object.freeze(catalog);
}());
